<template>
    <table class="pricesTable">
      <tr>
        <th>Name</th>
        <th>Base Price</th>
        <th>Handling</th>
        <th>GST</th>
        <th>Total</th>
        <th>% Saving</th>
      </tr>
      <tr>
        <td>Wholesale</td>
        <td></td>
        <td>-</td>
        <td>-</td>
        <td>{{CurrencyFormatter(product.all_prices.wholesale)}}</td>
        <td>-</td>
      </tr>
      <tr>
        <td>Retail</td>
        <td>{{CurrencyFormatter(product.all_prices.retail/1.15)}}</td>
        <td>-</td>
        <td>{{CurrencyFormatter(product.all_prices.retail*0.15)}}</td>
        <td>{{CurrencyFormatter(product.all_prices.retail)}}</td>
        <td>-</td>
      </tr>
      <tr v-for="(price, key) in prices" :key="key">
        <td>{{key}}</td>
        <td>{{CurrencyFormatter(price.base_price)}}</td>
        <!-- <td>{{CurrencyFormatter(price.base)}}   -->
        <td>{{CurrencyFormatter(price.handling_fee)}}</td>
        <td>{{CurrencyFormatter(price.gst)}}</td>
        <td>{{CurrencyFormatter(price.price)}}</td>
        <td>{{((1 - price.price/ parseFloat(product.retail_price))*100).toFixed(2)}}%</td>
      </tr>
    </table>
</template>

<script>
import {CurrencyFormatter} from "@/utils";

export default {
  name: "DebugProductPrices",
  components: {
  },
  props: ["product"],
  methods: {
    CurrencyFormatter,
  },
  computed:{
    prices(){
      const {silver, gold, platinum} = this.product.all_prices

      return {silver, gold, platinum}
    }
  }
};
</script>

<style lang="scss" scoped>

.pricesTable{
  text-transform: capitalize;
  margin:5px;
  td, th{
    text-align:right;
    padding:4px;
    border:1px solid grey;
  }
}
</style>
